export const languages = [
  {
    name: 'English',
    locale: 'en',
    dataLocale: 'en_US'
  },
  {
    name: 'Việt Nam',
    locale: 'vi',
    dataLocale: 'vi_VI'
  }
]
